import axios, { AxiosRequestConfig } from 'axios';
import { SERVER_URL } from '../../config';

export async function refreshExpiredToken() {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) {
    throw new Error('Refresh token is not set');
  }

  const headers = {
    headers: {
      Accept: 'application/json',
    },
  };
  const { data } = await axios.get(
    `${SERVER_URL}oauth2/refresh?refresh_token=${refreshToken}`,
    headers
  );

  const expires = new Date();
  expires.setSeconds(expires.getSeconds() + data.expires_in - 300);

  localStorage.setItem('access_token', data.access_token);
  localStorage.setItem('refresh_token', data.refresh_token);
  localStorage.setItem('id_token', data.id_token);
  localStorage.setItem('expires', expires as unknown as string);
}

export function isTokenExpired() {
  const expires = localStorage.getItem('expires');
  if (!expires) {
    return false;
  }
  return new Date(expires) < new Date();
}

export function addAuthHeaders(config: AxiosRequestConfig) {
  const accessToken = localStorage.getItem('access_token');
  const idToken = localStorage.getItem('id_token');

  if (accessToken && idToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers = Object.assign({}, config.headers, {
      Authorization: `Bearer ${accessToken}`,
      'X-Authorization': idToken,
    });
  }
  return config;
}
